import React from 'react';

interface Props extends React.PropsWithChildren {}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<Props> {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  state: Readonly<State> = {
    hasError: false,
  };

  componentDidCatch(error: any, info: any) {
    console.error(error, 'componentDidCatch');
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div>error rendering!</div>;
    }

    return <>{this.props.children}</>;
  }
}
